import axios from 'axios';

const LOG_ENDPOINT = '/v1/log/logMessage';

/**
 * Transmit a log entry to the api-log service.
 *
 * @param {('info'|'error')} level
 * @param {string} message
 * @param {object} [meta]
 */
export async function remoteLog(level, message, meta = {}) {
    try {
        await axios.post(
            LOG_ENDPOINT,
            {
                message,
                origin: 'ui',
                level,
                insertedBy: 'browser',
                ...meta
            },
            {
                withCredentials: true
            }
        );
    } catch (err) {
        console.error('remoteLog failed', err);
    }
}
